import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { api } from '../lib/api';
import { getCachedTheme } from '../lib/siteTheme';

const SiteSettingsContext = createContext({
  settings: null,
  loading: true,
  refresh: async () => {},
  setSettings: () => {},
});

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState(() => ({ theme: getCachedTheme() }));
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      setLoading(true);
      const response = await api.get('/settings');
      setSettings(response.data);
    } catch (error) {
      console.error('Failed to fetch site settings', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <SiteSettingsContext.Provider value={{ settings, loading, refresh, setSettings }}>
      {children}
    </SiteSettingsContext.Provider>
  );
}

export function useSiteSettings() {
  return useContext(SiteSettingsContext);
}
